export const initialValues = {
    name: '',
    description: '',
    image: '',
    icon: '',
};

export const pictureAttributeNames = [
    "image",
    "icon"
];
